(function(){
'use strict';
var S = 'malange-soldes-v3';
var SOLDES_URL = '/collections/soldes';

// Tous les produits SOLDE — prix vérifiés depuis Shopify
// Calcul : Math.round((1 - prix/compareAt) * 100)
var SALE_MAP = {
  'cagoule-balaclava-bubble':           { pct: 22, orig: '45 €' },       // 35/45
  'pantalon-cargo-bubble':              { pct: 42, orig: '60 €' },       // 35/60
  'tee-shirt-highschool':               { pct: 35, orig: '35 €' },       // 22.9/35
  'chemise-a-carreaux-fueille-de-copie':{ pct: 18, orig: '54,90 €' },   // 44.9/54.9
  'casquette-highschool':               { pct: 40, orig: '29,90 €' },   // 17.9/29.9
  'casquette-double-visiere-aether':    { pct: 18, orig: '39,90 €' },   // 32.9/39.9
  'tee-shirt-aether':                   { pct: 27, orig: '44,90 €' },   // 32.9/44.9
  'pantalon-denim-cargo-baggy-aether':  { pct: 25, orig: '79,90 €' }    // 59.9/79.9
};

// ============================================================
// 1. LIEN SOLDES dans la nav (rouge)
// ============================================================
function initNavLink(){
  var links = document.querySelectorAll('.header__nav-link, .nav-link, .site-nav__link, .site-nav a');
  var found = false;
  links.forEach(function(a){
    var txt = (a.textContent || '').trim().toUpperCase();
    if(txt === 'SOLDES' || txt === 'SALE' || (a.href && a.href.includes('/collections/soldes'))){
      a.classList.add('ma-nav-soldes-link');
      found = true;
    }
  });
  if(!found){
    var nav = document.querySelector('ul.site-nav, ul.header__nav, nav ul, .header__nav-items');
    if(nav){
      var li = document.createElement('li');
      li.style.cssText = 'list-style:none; display:inline-flex; align-items:center;';
      var a = document.createElement('a');
      a.href = SOLDES_URL;
      a.className = 'header__nav-link nav-link ma-nav-soldes-link';
      a.textContent = 'Soldes';
      li.appendChild(a);
      nav.appendChild(li);
    }
  }
}

// ============================================================
// 2. HERO PAGE COLLECTION SOLDES
// ============================================================
function initSoldesHero(){
  var wrap = document.querySelector('[data-handle="soldes"] .box__heading .site-box-content');
  if(!wrap || wrap.querySelector('.ma-hero-pct')) return;

  var pctEl = document.createElement('span');
  pctEl.className = 'ma-hero-pct';
  pctEl.textContent = 'Jusqu’à −42%';
  wrap.appendChild(pctEl);

  var meta = document.createElement('div');
  meta.className = 'ma-hero-meta';
  ['Stocks limités', 'Expédition 24-48h', 'Pièces sélectionnées'].forEach(function(txt){
    var line = document.createElement('div');
    line.className = 'ma-hero-meta-line';
    line.innerHTML = '<span class="ma-hero-meta-dot"></span>' + txt;
    meta.appendChild(line);
  });
  wrap.appendChild(meta);
}

// ============================================================
// 3. BADGES % + PRIX BARRÉS ROUGES sur les cards
// ============================================================
function initSaleBadges(){
  var items = document.querySelectorAll('.product-item, .product-holder');
  items.forEach(function(item){
    var link = item.querySelector('a[href*="/products/"]');
    var m = link && link.href.match(/\/products\/([^?#/]+)/);
    var handle = m ? m[1] : null;
    var data = handle ? SALE_MAP[handle] : null;

    // Badge % — coin image
    if(data && !item.querySelector('.ma-pct-badge')){
      var imgWrap = item.querySelector('.box--product-image, [class*="product-image"], figure, .product-image-container');
      if(imgWrap){
        if(getComputedStyle(imgWrap).position === 'static') imgWrap.style.position = 'relative';
        var badge = document.createElement('div');
        badge.className = 'ma-pct-badge';
        badge.textContent = '-' + data.pct + '%';
        imgWrap.appendChild(badge);
      }
    }

    // Prix barré rouge injecté si le thème ne l'affiche pas
    if(data && !item.querySelector('.ma-orig-price') && !item.querySelector('del') && !item.querySelector('s')){
      var priceEl = item.querySelector('.price, .caption .price');
      if(priceEl){
        var orig = document.createElement('span');
        orig.className = 'ma-orig-price';
        orig.textContent = data.orig;
        priceEl.appendChild(orig);
      }
    }
  });
}

// ============================================================
// 4. BADGE % FICHE PRODUIT
// ============================================================
function initPdpBadge(){
  if(!document.body.classList.contains('template-product')) return;
  var m = window.location.pathname.match(/\/products\/([^?#/]+)/);
  var data = m ? SALE_MAP[m[1]] : null;
  if(!data) return;
  var priceEl = document.querySelector('.product__price, .product-price, [class*="product__price"]');
  if(!priceEl || priceEl.querySelector('.ma-pdp-badge')) return;
  var badge = document.createElement('span');
  badge.className = 'ma-pdp-badge';
  badge.textContent = '-' + data.pct + '%';
  priceEl.appendChild(badge);
}

// ============================================================
// 5. POP-UP SOLDES — 7 secondes
// ============================================================
function initPopup(){
  try { if(sessionStorage.getItem(S+'-seen')) return; } catch(e){}
  try { if(localStorage.getItem(S+'-date') === new Date().toDateString()) return; } catch(e){}
  var body = document.body.className;
  if(['template-cart','template-checkout','template-password'].some(function(c){ return body.indexOf(c)!==-1; })) return;

  var ov = document.createElement('div');
  ov.id = 'ma-soldes-overlay';
  ov.setAttribute('role','dialog');
  ov.setAttribute('aria-modal','true');
  ov.innerHTML = [
    '<div class="ma-soldes-popup">',
      '<button class="ma-sp-close" aria-label="Fermer">&times;</button>',
      '<div class="ma-sp-visual">',
        '<div class="ma-sp-visual-bar"></div>',
        '<span class="ma-sp-pct">&minus;42%</span>',
        '<div class="ma-sp-pct-sub">Soldes &mdash; Pièces sélectionnées</div>',
      '</div>',
      '<div class="ma-sp-body">',
        '<div class="ma-sp-eyebrow">Soldes en cours</div>',
        '<div class="ma-sp-title">Jusqu’à &minus;42%<br>sur les pièces MalAnge</div>',
        '<div class="ma-sp-desc">Pantalons, tee-shirts, casquettes &mdash; stocks limités.</div>',
        '<a href="'+SOLDES_URL+'" class="ma-sp-btn">Voir les pièces soldées →</a>',
        '<div class="ma-sp-skip" id="ma-sp-skip">Continuer sans voir</div>',
      '</div>',
    '</div>'
  ].join('');
  document.body.appendChild(ov);

  function close(){
    ov.classList.remove('is-open');
    setTimeout(function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); }, 500);
    try { sessionStorage.setItem(S+'-seen','1'); } catch(e){}
    try { localStorage.setItem(S+'-date', new Date().toDateString()); } catch(e){}
  }
  ov.querySelector('.ma-sp-close').addEventListener('click', close);
  ov.querySelector('#ma-sp-skip').addEventListener('click', close);
  ov.addEventListener('click', function(e){ if(e.target===ov) close(); });
  document.addEventListener('keydown', function h(e){
    if(e.key==='Escape'||e.keyCode===27){ close(); document.removeEventListener('keydown',h); }
  });
  setTimeout(function(){
    ov.classList.add('is-open');
    ov.querySelector('.ma-sp-close').focus();
  }, 7000);
}

// ============================================================
// 6. NEWSLETTER NATIVE — décalée 90s
// ============================================================
function delayNewsletter(){
  document.body.classList.add('ma-nl-hidden');
  setTimeout(function(){ document.body.classList.remove('ma-nl-hidden'); }, 90000);
}

// ============================================================
// INIT
// ============================================================
function init(){
  initNavLink();
  initSoldesHero();
  initSaleBadges();
  initPdpBadge();
  initPopup();
  delayNewsletter();
  var grid = document.querySelector('#ProductGridContainer, #CollectionProductGrid');
  if(grid) new MutationObserver(function(){ initSaleBadges(); initSoldesHero(); }).observe(grid, {childList:true, subtree:true});
}

if(document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);

})();
